import styled from 'styled-components';

export const PdfContent = styled.iframe`
  width: 100%;
  height: 65vh;
`;
